export default __webpack_public_path__ + "static/media/BTC.7c8da557.svg";